import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
  HttpResponseBase,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import moment from 'moment';
import { map, Observable, tap } from 'rxjs';
import { LoggerService } from 'src/app/services/infra/logger/logger.service';
import { UserService } from 'src/app/services/infra/user/user.service';
import { v4 as uuidv4 } from 'uuid';

@Injectable()
export class HttpPerformanceInterceptor implements HttpInterceptor {
  constructor(
    private readonly _logger: LoggerService,
    private readonly _userService: UserService
  ) {}

  public intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const startTime = moment();
    const request_correlation_id: string = uuidv4();

    // let modifiedRequest = request.clone({ headers: request.headers.set('User-Session-Id', this._userService.sessionId).set('Request-Correlation-Id', request_correlation_id).set('Request-Start-Time', startTime.toString()) });

    return next.handle(request).pipe(
      map((event) => {
        if (event instanceof HttpResponse) {
          const endTime = moment();
          const requestTime = endTime.diff(startTime, 'milliseconds');

          const attributes = this._createAttributesForLog(
            event,
            startTime,
            endTime,
            requestTime,
            this._userService.sessionId,
            request_correlation_id
          );
          this._logger.info(
            `${this._userService.zenityAccountId}: ${event.status} ${event.url} in ${requestTime} ms - started: ${startTime.toISOString()}  end: ${endTime.toISOString()}`,
            attributes
          );
        }
        return event;
      }),
      tap({
        error: (error) => {
          if (error instanceof HttpErrorResponse) {
            const endTime = moment();
            const requestTime = endTime.diff(startTime, 'milliseconds');

            const attributes = this._createAttributesForLog(
              error,
              startTime,
              endTime,
              requestTime,
              this._userService.sessionId,
              request_correlation_id
            );
            const logText = `${this._userService.zenityAccountId}: ${error.status} ${error.url} in ${requestTime} ms - started: ${startTime.toISOString()}  end: ${endTime.toISOString()}`;

            // Log 403/404 as warn (not error) — 403 avoids alert dialogs, 404 is expected for optional resources
            if (error.status < 400 || error.status === 403 || error.status === 404) {
              this._logger.warn(logText, attributes);
            } else {
              this._logger.error(logText, attributes);
            }
          }
        },
      })
    );
  }

  private _createAttributesForLog(
    httpResponse: HttpResponseBase,
    startTime: moment.Moment,
    endTime: moment.Moment,
    requestTime: number,
    sessionId: string,
    request_correlation_id: string
  ) {
    return {
      endpoint_url: httpResponse.url,
      status_code: httpResponse.status,
      start_time: startTime.toISOString(),
      end_time: endTime.toISOString(),
      request_time_ms: requestTime,
      session_id: sessionId,
      request_correlation_id: request_correlation_id,
    };
  }
}
